<mat-card class="cardWithShadow">
    <mat-card-content>

        <div class="container_button_company" style="margin-bottom: 15px;">
            <mat-card-title>Garantías</mat-card-title>
        </div>

        <div style="text-align: center;"  *ngIf="dataSource.data.length == 0">
            <h3>No se encontraron Garantías en el rango</h3>
        </div>

        <div class="overflow-table" [ngClass]="{ 'oculto': dataSource.data.length == 0 }">
            <table mat-table matSort (matSortChange)="changeSorting($event)" [dataSource]="dataSource">
                <ng-container matColumnDef="WarrantyType">
                    <th class="th-header" mat-header-cell *matHeaderCellDef>
                        Tipo
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <h6>{{ element.warrantyType }}</h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="InsuranceName">
                    <th mat-sort-header class="th-header" mat-header-cell *matHeaderCellDef>
                        Aseguradora
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <h6>{{ element.insuranceName }}</h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="CreatedAt">
                    <th mat-sort-header class="th-header" mat-header-cell *matHeaderCellDef>
                        Solicitado
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <h6 class="single-line">{{ element.createdAt | date : 'dd-MM-yyyy' }}</h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="ProviderRut">
                    <th mat-sort-header class="th-header" mat-header-cell *matHeaderCellDef>
                        RUT Proveedor
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <h6 class="single-line">{{ element.providerRut }}</h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="ProviderName">
                    <th mat-sort-header class="th-header" mat-header-cell *matHeaderCellDef>
                        Nombre Proveedor
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <h6>{{ element.providerName }}</h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="ProviderPhone">
                    <th mat-sort-header class="th-header" mat-header-cell *matHeaderCellDef>
                        Telefono
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <h6 class="single-line">{{ element.providerPhone }}</h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="ProviderEmail">
                    <th mat-sort-header class="th-header" mat-header-cell *matHeaderCellDef>
                        Correo
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <h6 class="single-line">{{ element.providerEmail }}</h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="Amount">
                    <th mat-sort-header class="th-header" mat-header-cell *matHeaderCellDef>
                        Monto
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <h6>{{ element.amount | currency : 'CLP' }}</h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="Cost">
                    <th mat-sort-header class="th-header" mat-header-cell *matHeaderCellDef>
                        Comisión
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <h6>{{ element.cost | currency: 'CLP' }}</h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="Code">
                    <th mat-sort-header class="th-header" mat-header-cell *matHeaderCellDef>
                        Código
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <h6>
                            <a *ngIf="element.tenderCode" target="_blank" href="https://garantiaschilecompra.cl/client/document/downloaddocument?c={{element.code}}" class="primary-anchor">
                                {{ element.code }}
                            </a>
                        </h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="TenderBuyerRut">
                    <th mat-sort-header class="th-header" mat-header-cell *matHeaderCellDef>
                        RUT Mandante
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <h6 class="single-line">{{ element.tenderBuyerRut }}</h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="TenderBuyerName">
                    <th mat-sort-header class="th-header" mat-header-cell *matHeaderCellDef>
                        Nombre Mandante
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <h6>{{ element.tenderBuyerName }}</h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="TenderCode">
                    <th mat-sort-header class="th-header" mat-header-cell *matHeaderCellDef>
                        Licitación
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <h6>
                            <a class="single-line secondary-anchor" *ngIf="element.tenderCode" target="_blank" href="http://www.mercadopublico.cl/Procurement/Modules/RFB/DetailsAcquisition.aspx?idlicitacion={{element.tenderCode}}">
                                {{ element.tenderCode }}
                            </a>
                        </h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="EmissionDate">
                    <th mat-sort-header class="th-header" mat-header-cell *matHeaderCellDef>
                        Emisión
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <h6 class="single-line">
                            {{ element.emissionDate | date: 'dd-MM-yyyy'}}
                        </h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="AmountType">
                    <th class="th-header" mat-header-cell *matHeaderCellDef>
                        Moneda
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <h6 class="single-line">
                            {{ element.amountType }}
                        </h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="DaysWarrantyDuration">
                    <th mat-sort-header class="th-header" mat-header-cell *matHeaderCellDef>
                        Vigencía Garantía
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <h6>{{ element.daysWarrantyDuration }} días</h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="Status">
                    <th mat-sort-header class="th-header" mat-header-cell *matHeaderCellDef>
                        Estado
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <h6 class="single-line">{{ element.status }}</h6>
                    </td>
                </ng-container>

                <ng-container matColumnDef="IsConstruccion">
                    <th mat-sort-header class="th-header" mat-header-cell *matHeaderCellDef>
                        Es Construccion
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <h6 class="single-line" *ngIf="element.isConstruccion">
                            <i-tabler name="circle-check-filled" class="icon-20" style="color: mediumspringgreen">
                            </i-tabler>
                        </h6>

                        <h6 class="single-line" *ngIf="!element.isConstruccion">
                            <i-tabler name="circle-x-filled" class="icon-20" style="color: red">
                            </i-tabler>
                        </h6>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayCols"></tr>
                <tr mat-row [cdkContextMenuTriggerFor]="menu" *matRowDef="let row; columns: displayCols">

                    <ng-template #menu>
                        <div cdkMenu class="context_menu mat-elevation-z0" style="z-index: 999">
                            <span *ngIf="permissionForUpdateWarrantieBuild">
                                <button
                                class="context-menu-item"
                                cdkMenuItem
                                mat-flat-button
                                (click)="openModalConstruccion(row)"
                                >
                                    Cambiar Construcción
                                </button>
                            </span>
                        </div>
                    </ng-template>

                </tr>
            </table>
        </div>
        <div>
            <mat-paginator (page)="changePagination($event)" [pageSizeOptions]="[5, 10]"></mat-paginator>
        </div>
    </mat-card-content>
</mat-card>

